module.exports = __webpack_public_path__ + "img/people-38.4f4303ee.png";